/**
 * Dynamicznie ustawia margin-top dla main na podstawie wysokości headera
 */
export function initHeaderOffset() {
    const header = document.querySelector('.l-header');
    const main = document.querySelector('main');
    
    if (!header || !main) {
        return;
    }
    
    function updateMainOffset() {
        const headerHeight = header.offsetHeight;
        main.style.marginTop = `${headerHeight}px`;
    }
    
    // Ustaw początkowy margin
    updateMainOffset();
    
    // Aktualizuj przy resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            updateMainOffset();
        }, 100);
    });
    
    // Obserwuj zmiany wysokości headera (np. przy sticky header)
    if (typeof ResizeObserver !== 'undefined') {
        const resizeObserver = new ResizeObserver(() => {
            updateMainOffset();
        });
        resizeObserver.observe(header);
    }
}

/**
 * Dynamicznie ustawia top dla .gallery__tabs na podstawie wysokości headera + 25px
 */
export function initGalleryTabsOffset() {
    const header = document.querySelector('.l-header');
    const galleryTabs = document.querySelector('.gallery__tabs');
    
    if (!header || !galleryTabs) {
        return;
    }
    
    function updateGalleryTabsOffset() {
        const headerHeight = header.offsetHeight;
        let adminBarOffset = 0;
        if (document.body.classList.contains('admin-bar')) {
            adminBarOffset = window.innerWidth < 782 ? 45 : 30;
        }
        galleryTabs.style.top = `${headerHeight + adminBarOffset}px`;
    }
    
    // Ustaw początkową wartość
    updateGalleryTabsOffset();
    
    // Aktualizuj przy resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            updateGalleryTabsOffset();
        }, 100);
    });
    
    // Obserwuj zmiany wysokości headera
    if (typeof ResizeObserver !== 'undefined') {
        const resizeObserver = new ResizeObserver(() => {
            updateGalleryTabsOffset();
        });
        resizeObserver.observe(header);
    }
}
